/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateRunbookRequestRunbook } from '../models';
// @ts-ignore
import type { ListRunbookIntegrationsResponse } from '../models';
// @ts-ignore
import type { ListRunbooksOrganizationResponse } from '../models';
// @ts-ignore
import type { ListRunbooksResponse } from '../models';
// @ts-ignore
import type { Runbook } from '../models';
// @ts-ignore
import type { Status } from '../models';
// @ts-ignore
import type { UpdateRunbookRequestRunbook } from '../models';
/**
 * RunbooksAPIApi - axios parameter creator
 * @export
 */
export const RunbooksAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add integrations to a runbook.
         * @summary Add integrations to a given runbook.
         * @param {string} organizationId The ID of the organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} runbookId The ID of the runbook.
         * @param {Array<string>} [integrationIds] The integration IDs to add.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runbooksAPIAddRunbookIntegrations: async (organizationId: string, clusterId: string, runbookId: string, integrationIds?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('runbooksAPIAddRunbookIntegrations', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('runbooksAPIAddRunbookIntegrations', 'clusterId', clusterId)
            // verify required parameter 'runbookId' is not null or undefined
            assertParamExists('runbooksAPIAddRunbookIntegrations', 'runbookId', runbookId)
            const localVarPath = `/application-automation/v1alpha/organizations/{organizationId}/clusters/{clusterId}/runbooks/{runbookId}/integrations`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"runbookId"}}`, encodeURIComponent(String(runbookId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (integrationIds) {
                localVarQueryParameter['integrationIds'] = integrationIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Inserts new runbook for the given cluster.
         * @summary Creates a new runbook for the given cluster.
         * @param {string} runbookOrganizationId 
         * @param {string} runbookClusterId 
         * @param {CreateRunbookRequestRunbook} createRunbookRequestRunbook 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runbooksAPICreateRunbook: async (runbookOrganizationId: string, runbookClusterId: string, createRunbookRequestRunbook: CreateRunbookRequestRunbook, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'runbookOrganizationId' is not null or undefined
            assertParamExists('runbooksAPICreateRunbook', 'runbookOrganizationId', runbookOrganizationId)
            // verify required parameter 'runbookClusterId' is not null or undefined
            assertParamExists('runbooksAPICreateRunbook', 'runbookClusterId', runbookClusterId)
            // verify required parameter 'createRunbookRequestRunbook' is not null or undefined
            assertParamExists('runbooksAPICreateRunbook', 'createRunbookRequestRunbook', createRunbookRequestRunbook)
            const localVarPath = `/application-automation/v1alpha/organizations/{runbook.organization_id}/clusters/{runbook.cluster_id}/runbooks`
                .replace(`{${"runbook.organization_id"}}`, encodeURIComponent(String(runbookOrganizationId)))
                .replace(`{${"runbook.cluster_id"}}`, encodeURIComponent(String(runbookClusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRunbookRequestRunbook, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes the runbook for the given cluster.
         * @summary Delete runbooks for the given cluster.
         * @param {string} organizationId The ID of the organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} id The ID of the runbook.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runbooksAPIDeleteRunbook: async (organizationId: string, clusterId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('runbooksAPIDeleteRunbook', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('runbooksAPIDeleteRunbook', 'clusterId', clusterId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('runbooksAPIDeleteRunbook', 'id', id)
            const localVarPath = `/application-automation/v1alpha/organizations/{organizationId}/clusters/{clusterId}/runbooks/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete integrations from a runbook.
         * @summary Delete integrations from a given runbook.
         * @param {string} organizationId The ID of the organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} runbookId The ID of the runbook.
         * @param {Array<string>} [integrationIds] The integration IDs to delete.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runbooksAPIDeleteRunbookIntegrations: async (organizationId: string, clusterId: string, runbookId: string, integrationIds?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('runbooksAPIDeleteRunbookIntegrations', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('runbooksAPIDeleteRunbookIntegrations', 'clusterId', clusterId)
            // verify required parameter 'runbookId' is not null or undefined
            assertParamExists('runbooksAPIDeleteRunbookIntegrations', 'runbookId', runbookId)
            const localVarPath = `/application-automation/v1alpha/organizations/{organizationId}/clusters/{clusterId}/runbooks/{runbookId}/integrations`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"runbookId"}}`, encodeURIComponent(String(runbookId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (integrationIds) {
                localVarQueryParameter['integrationIds'] = integrationIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List integrations for a runbook.
         * @summary List integrations for the given runbook.
         * @param {string} organizationId The ID of the organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} runbookId The ID of the runbook.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runbooksAPIListRunbookIntegrations: async (organizationId: string, clusterId: string, runbookId: string, pageLimit?: string, pageCursor?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('runbooksAPIListRunbookIntegrations', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('runbooksAPIListRunbookIntegrations', 'clusterId', clusterId)
            // verify required parameter 'runbookId' is not null or undefined
            assertParamExists('runbooksAPIListRunbookIntegrations', 'runbookId', runbookId)
            const localVarPath = `/application-automation/v1alpha/organizations/{organizationId}/clusters/{clusterId}/runbooks/{runbookId}/integrations`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"runbookId"}}`, encodeURIComponent(String(runbookId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List runbooks for the given cluster.
         * @summary List runbooks for the given cluster.
         * @param {string} organizationId The ID of the organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runbooksAPIListRunbooks: async (organizationId: string, clusterId: string, pageLimit?: string, pageCursor?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('runbooksAPIListRunbooks', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('runbooksAPIListRunbooks', 'clusterId', clusterId)
            const localVarPath = `/application-automation/v1alpha/organizations/{organizationId}/clusters/{clusterId}/runbooks`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List runbooks for the given organization.
         * @summary List runbooks for the given organization.
         * @param {string} organizationId The ID of the organization.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runbooksAPIListRunbooksOrganization: async (organizationId: string, pageLimit?: string, pageCursor?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('runbooksAPIListRunbooksOrganization', 'organizationId', organizationId)
            const localVarPath = `/application-automation/v1alpha/organizations/{organizationId}/runbooks`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates runbook for the given cluster.
         * @summary Updates a runbook for the given cluster.
         * @param {string} runbookOrganizationId 
         * @param {string} runbookClusterId 
         * @param {string} runbookId 
         * @param {UpdateRunbookRequestRunbook} updateRunbookRequestRunbook 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runbooksAPIUpdateRunbook: async (runbookOrganizationId: string, runbookClusterId: string, runbookId: string, updateRunbookRequestRunbook: UpdateRunbookRequestRunbook, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'runbookOrganizationId' is not null or undefined
            assertParamExists('runbooksAPIUpdateRunbook', 'runbookOrganizationId', runbookOrganizationId)
            // verify required parameter 'runbookClusterId' is not null or undefined
            assertParamExists('runbooksAPIUpdateRunbook', 'runbookClusterId', runbookClusterId)
            // verify required parameter 'runbookId' is not null or undefined
            assertParamExists('runbooksAPIUpdateRunbook', 'runbookId', runbookId)
            // verify required parameter 'updateRunbookRequestRunbook' is not null or undefined
            assertParamExists('runbooksAPIUpdateRunbook', 'updateRunbookRequestRunbook', updateRunbookRequestRunbook)
            const localVarPath = `/application-automation/v1alpha/organizations/{runbook.organization_id}/clusters/{runbook.cluster_id}/runbooks/{runbook.id}`
                .replace(`{${"runbook.organization_id"}}`, encodeURIComponent(String(runbookOrganizationId)))
                .replace(`{${"runbook.cluster_id"}}`, encodeURIComponent(String(runbookClusterId)))
                .replace(`{${"runbook.id"}}`, encodeURIComponent(String(runbookId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRunbookRequestRunbook, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RunbooksAPIApi - functional programming interface
 * @export
 */
export const RunbooksAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RunbooksAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Add integrations to a runbook.
         * @summary Add integrations to a given runbook.
         * @param {string} organizationId The ID of the organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} runbookId The ID of the runbook.
         * @param {Array<string>} [integrationIds] The integration IDs to add.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runbooksAPIAddRunbookIntegrations(organizationId: string, clusterId: string, runbookId: string, integrationIds?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runbooksAPIAddRunbookIntegrations(organizationId, clusterId, runbookId, integrationIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RunbooksAPIApi.runbooksAPIAddRunbookIntegrations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Inserts new runbook for the given cluster.
         * @summary Creates a new runbook for the given cluster.
         * @param {string} runbookOrganizationId 
         * @param {string} runbookClusterId 
         * @param {CreateRunbookRequestRunbook} createRunbookRequestRunbook 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runbooksAPICreateRunbook(runbookOrganizationId: string, runbookClusterId: string, createRunbookRequestRunbook: CreateRunbookRequestRunbook, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Runbook>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runbooksAPICreateRunbook(runbookOrganizationId, runbookClusterId, createRunbookRequestRunbook, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RunbooksAPIApi.runbooksAPICreateRunbook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes the runbook for the given cluster.
         * @summary Delete runbooks for the given cluster.
         * @param {string} organizationId The ID of the organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} id The ID of the runbook.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runbooksAPIDeleteRunbook(organizationId: string, clusterId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runbooksAPIDeleteRunbook(organizationId, clusterId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RunbooksAPIApi.runbooksAPIDeleteRunbook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete integrations from a runbook.
         * @summary Delete integrations from a given runbook.
         * @param {string} organizationId The ID of the organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} runbookId The ID of the runbook.
         * @param {Array<string>} [integrationIds] The integration IDs to delete.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runbooksAPIDeleteRunbookIntegrations(organizationId: string, clusterId: string, runbookId: string, integrationIds?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runbooksAPIDeleteRunbookIntegrations(organizationId, clusterId, runbookId, integrationIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RunbooksAPIApi.runbooksAPIDeleteRunbookIntegrations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List integrations for a runbook.
         * @summary List integrations for the given runbook.
         * @param {string} organizationId The ID of the organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} runbookId The ID of the runbook.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runbooksAPIListRunbookIntegrations(organizationId: string, clusterId: string, runbookId: string, pageLimit?: string, pageCursor?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListRunbookIntegrationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runbooksAPIListRunbookIntegrations(organizationId, clusterId, runbookId, pageLimit, pageCursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RunbooksAPIApi.runbooksAPIListRunbookIntegrations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List runbooks for the given cluster.
         * @summary List runbooks for the given cluster.
         * @param {string} organizationId The ID of the organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runbooksAPIListRunbooks(organizationId: string, clusterId: string, pageLimit?: string, pageCursor?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListRunbooksResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runbooksAPIListRunbooks(organizationId, clusterId, pageLimit, pageCursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RunbooksAPIApi.runbooksAPIListRunbooks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List runbooks for the given organization.
         * @summary List runbooks for the given organization.
         * @param {string} organizationId The ID of the organization.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runbooksAPIListRunbooksOrganization(organizationId: string, pageLimit?: string, pageCursor?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListRunbooksOrganizationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runbooksAPIListRunbooksOrganization(organizationId, pageLimit, pageCursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RunbooksAPIApi.runbooksAPIListRunbooksOrganization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates runbook for the given cluster.
         * @summary Updates a runbook for the given cluster.
         * @param {string} runbookOrganizationId 
         * @param {string} runbookClusterId 
         * @param {string} runbookId 
         * @param {UpdateRunbookRequestRunbook} updateRunbookRequestRunbook 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runbooksAPIUpdateRunbook(runbookOrganizationId: string, runbookClusterId: string, runbookId: string, updateRunbookRequestRunbook: UpdateRunbookRequestRunbook, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Runbook>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runbooksAPIUpdateRunbook(runbookOrganizationId, runbookClusterId, runbookId, updateRunbookRequestRunbook, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RunbooksAPIApi.runbooksAPIUpdateRunbook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RunbooksAPIApi - factory interface
 * @export
 */
export const RunbooksAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RunbooksAPIApiFp(configuration)
    return {
        /**
         * Add integrations to a runbook.
         * @summary Add integrations to a given runbook.
         * @param {RunbooksAPIApiRunbooksAPIAddRunbookIntegrationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runbooksAPIAddRunbookIntegrations(requestParameters: RunbooksAPIApiRunbooksAPIAddRunbookIntegrationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.runbooksAPIAddRunbookIntegrations(requestParameters.organizationId, requestParameters.clusterId, requestParameters.runbookId, requestParameters.integrationIds, options).then((request) => request(axios, basePath));
        },
        /**
         * Inserts new runbook for the given cluster.
         * @summary Creates a new runbook for the given cluster.
         * @param {RunbooksAPIApiRunbooksAPICreateRunbookRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runbooksAPICreateRunbook(requestParameters: RunbooksAPIApiRunbooksAPICreateRunbookRequest, options?: RawAxiosRequestConfig): AxiosPromise<Runbook> {
            return localVarFp.runbooksAPICreateRunbook(requestParameters.runbookOrganizationId, requestParameters.runbookClusterId, requestParameters.createRunbookRequestRunbook, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes the runbook for the given cluster.
         * @summary Delete runbooks for the given cluster.
         * @param {RunbooksAPIApiRunbooksAPIDeleteRunbookRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runbooksAPIDeleteRunbook(requestParameters: RunbooksAPIApiRunbooksAPIDeleteRunbookRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.runbooksAPIDeleteRunbook(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete integrations from a runbook.
         * @summary Delete integrations from a given runbook.
         * @param {RunbooksAPIApiRunbooksAPIDeleteRunbookIntegrationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runbooksAPIDeleteRunbookIntegrations(requestParameters: RunbooksAPIApiRunbooksAPIDeleteRunbookIntegrationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.runbooksAPIDeleteRunbookIntegrations(requestParameters.organizationId, requestParameters.clusterId, requestParameters.runbookId, requestParameters.integrationIds, options).then((request) => request(axios, basePath));
        },
        /**
         * List integrations for a runbook.
         * @summary List integrations for the given runbook.
         * @param {RunbooksAPIApiRunbooksAPIListRunbookIntegrationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runbooksAPIListRunbookIntegrations(requestParameters: RunbooksAPIApiRunbooksAPIListRunbookIntegrationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListRunbookIntegrationsResponse> {
            return localVarFp.runbooksAPIListRunbookIntegrations(requestParameters.organizationId, requestParameters.clusterId, requestParameters.runbookId, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(axios, basePath));
        },
        /**
         * List runbooks for the given cluster.
         * @summary List runbooks for the given cluster.
         * @param {RunbooksAPIApiRunbooksAPIListRunbooksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runbooksAPIListRunbooks(requestParameters: RunbooksAPIApiRunbooksAPIListRunbooksRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListRunbooksResponse> {
            return localVarFp.runbooksAPIListRunbooks(requestParameters.organizationId, requestParameters.clusterId, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(axios, basePath));
        },
        /**
         * List runbooks for the given organization.
         * @summary List runbooks for the given organization.
         * @param {RunbooksAPIApiRunbooksAPIListRunbooksOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runbooksAPIListRunbooksOrganization(requestParameters: RunbooksAPIApiRunbooksAPIListRunbooksOrganizationRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListRunbooksOrganizationResponse> {
            return localVarFp.runbooksAPIListRunbooksOrganization(requestParameters.organizationId, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates runbook for the given cluster.
         * @summary Updates a runbook for the given cluster.
         * @param {RunbooksAPIApiRunbooksAPIUpdateRunbookRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runbooksAPIUpdateRunbook(requestParameters: RunbooksAPIApiRunbooksAPIUpdateRunbookRequest, options?: RawAxiosRequestConfig): AxiosPromise<Runbook> {
            return localVarFp.runbooksAPIUpdateRunbook(requestParameters.runbookOrganizationId, requestParameters.runbookClusterId, requestParameters.runbookId, requestParameters.updateRunbookRequestRunbook, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for runbooksAPIAddRunbookIntegrations operation in RunbooksAPIApi.
 * @export
 * @interface RunbooksAPIApiRunbooksAPIAddRunbookIntegrationsRequest
 */
export interface RunbooksAPIApiRunbooksAPIAddRunbookIntegrationsRequest {
    /**
     * The ID of the organization.
     * @type {string}
     * @memberof RunbooksAPIApiRunbooksAPIAddRunbookIntegrations
     */
    readonly organizationId: string

    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof RunbooksAPIApiRunbooksAPIAddRunbookIntegrations
     */
    readonly clusterId: string

    /**
     * The ID of the runbook.
     * @type {string}
     * @memberof RunbooksAPIApiRunbooksAPIAddRunbookIntegrations
     */
    readonly runbookId: string

    /**
     * The integration IDs to add.
     * @type {Array<string>}
     * @memberof RunbooksAPIApiRunbooksAPIAddRunbookIntegrations
     */
    readonly integrationIds?: Array<string>
}

/**
 * Request parameters for runbooksAPICreateRunbook operation in RunbooksAPIApi.
 * @export
 * @interface RunbooksAPIApiRunbooksAPICreateRunbookRequest
 */
export interface RunbooksAPIApiRunbooksAPICreateRunbookRequest {
    /**
     * 
     * @type {string}
     * @memberof RunbooksAPIApiRunbooksAPICreateRunbook
     */
    readonly runbookOrganizationId: string

    /**
     * 
     * @type {string}
     * @memberof RunbooksAPIApiRunbooksAPICreateRunbook
     */
    readonly runbookClusterId: string

    /**
     * 
     * @type {CreateRunbookRequestRunbook}
     * @memberof RunbooksAPIApiRunbooksAPICreateRunbook
     */
    readonly createRunbookRequestRunbook: CreateRunbookRequestRunbook
}

/**
 * Request parameters for runbooksAPIDeleteRunbook operation in RunbooksAPIApi.
 * @export
 * @interface RunbooksAPIApiRunbooksAPIDeleteRunbookRequest
 */
export interface RunbooksAPIApiRunbooksAPIDeleteRunbookRequest {
    /**
     * The ID of the organization.
     * @type {string}
     * @memberof RunbooksAPIApiRunbooksAPIDeleteRunbook
     */
    readonly organizationId: string

    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof RunbooksAPIApiRunbooksAPIDeleteRunbook
     */
    readonly clusterId: string

    /**
     * The ID of the runbook.
     * @type {string}
     * @memberof RunbooksAPIApiRunbooksAPIDeleteRunbook
     */
    readonly id: string
}

/**
 * Request parameters for runbooksAPIDeleteRunbookIntegrations operation in RunbooksAPIApi.
 * @export
 * @interface RunbooksAPIApiRunbooksAPIDeleteRunbookIntegrationsRequest
 */
export interface RunbooksAPIApiRunbooksAPIDeleteRunbookIntegrationsRequest {
    /**
     * The ID of the organization.
     * @type {string}
     * @memberof RunbooksAPIApiRunbooksAPIDeleteRunbookIntegrations
     */
    readonly organizationId: string

    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof RunbooksAPIApiRunbooksAPIDeleteRunbookIntegrations
     */
    readonly clusterId: string

    /**
     * The ID of the runbook.
     * @type {string}
     * @memberof RunbooksAPIApiRunbooksAPIDeleteRunbookIntegrations
     */
    readonly runbookId: string

    /**
     * The integration IDs to delete.
     * @type {Array<string>}
     * @memberof RunbooksAPIApiRunbooksAPIDeleteRunbookIntegrations
     */
    readonly integrationIds?: Array<string>
}

/**
 * Request parameters for runbooksAPIListRunbookIntegrations operation in RunbooksAPIApi.
 * @export
 * @interface RunbooksAPIApiRunbooksAPIListRunbookIntegrationsRequest
 */
export interface RunbooksAPIApiRunbooksAPIListRunbookIntegrationsRequest {
    /**
     * The ID of the organization.
     * @type {string}
     * @memberof RunbooksAPIApiRunbooksAPIListRunbookIntegrations
     */
    readonly organizationId: string

    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof RunbooksAPIApiRunbooksAPIListRunbookIntegrations
     */
    readonly clusterId: string

    /**
     * The ID of the runbook.
     * @type {string}
     * @memberof RunbooksAPIApiRunbooksAPIListRunbookIntegrations
     */
    readonly runbookId: string

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof RunbooksAPIApiRunbooksAPIListRunbookIntegrations
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof RunbooksAPIApiRunbooksAPIListRunbookIntegrations
     */
    readonly pageCursor?: string
}

/**
 * Request parameters for runbooksAPIListRunbooks operation in RunbooksAPIApi.
 * @export
 * @interface RunbooksAPIApiRunbooksAPIListRunbooksRequest
 */
export interface RunbooksAPIApiRunbooksAPIListRunbooksRequest {
    /**
     * The ID of the organization.
     * @type {string}
     * @memberof RunbooksAPIApiRunbooksAPIListRunbooks
     */
    readonly organizationId: string

    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof RunbooksAPIApiRunbooksAPIListRunbooks
     */
    readonly clusterId: string

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof RunbooksAPIApiRunbooksAPIListRunbooks
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof RunbooksAPIApiRunbooksAPIListRunbooks
     */
    readonly pageCursor?: string
}

/**
 * Request parameters for runbooksAPIListRunbooksOrganization operation in RunbooksAPIApi.
 * @export
 * @interface RunbooksAPIApiRunbooksAPIListRunbooksOrganizationRequest
 */
export interface RunbooksAPIApiRunbooksAPIListRunbooksOrganizationRequest {
    /**
     * The ID of the organization.
     * @type {string}
     * @memberof RunbooksAPIApiRunbooksAPIListRunbooksOrganization
     */
    readonly organizationId: string

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof RunbooksAPIApiRunbooksAPIListRunbooksOrganization
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof RunbooksAPIApiRunbooksAPIListRunbooksOrganization
     */
    readonly pageCursor?: string
}

/**
 * Request parameters for runbooksAPIUpdateRunbook operation in RunbooksAPIApi.
 * @export
 * @interface RunbooksAPIApiRunbooksAPIUpdateRunbookRequest
 */
export interface RunbooksAPIApiRunbooksAPIUpdateRunbookRequest {
    /**
     * 
     * @type {string}
     * @memberof RunbooksAPIApiRunbooksAPIUpdateRunbook
     */
    readonly runbookOrganizationId: string

    /**
     * 
     * @type {string}
     * @memberof RunbooksAPIApiRunbooksAPIUpdateRunbook
     */
    readonly runbookClusterId: string

    /**
     * 
     * @type {string}
     * @memberof RunbooksAPIApiRunbooksAPIUpdateRunbook
     */
    readonly runbookId: string

    /**
     * 
     * @type {UpdateRunbookRequestRunbook}
     * @memberof RunbooksAPIApiRunbooksAPIUpdateRunbook
     */
    readonly updateRunbookRequestRunbook: UpdateRunbookRequestRunbook
}

/**
 * RunbooksAPIApi - object-oriented interface
 * @export
 * @class RunbooksAPIApi
 * @extends {BaseAPI}
 */
export class RunbooksAPIApi extends BaseAPI {
    /**
     * Add integrations to a runbook.
     * @summary Add integrations to a given runbook.
     * @param {RunbooksAPIApiRunbooksAPIAddRunbookIntegrationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RunbooksAPIApi
     */
    public runbooksAPIAddRunbookIntegrations(requestParameters: RunbooksAPIApiRunbooksAPIAddRunbookIntegrationsRequest, options?: RawAxiosRequestConfig) {
        return RunbooksAPIApiFp(this.configuration).runbooksAPIAddRunbookIntegrations(requestParameters.organizationId, requestParameters.clusterId, requestParameters.runbookId, requestParameters.integrationIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Inserts new runbook for the given cluster.
     * @summary Creates a new runbook for the given cluster.
     * @param {RunbooksAPIApiRunbooksAPICreateRunbookRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RunbooksAPIApi
     */
    public runbooksAPICreateRunbook(requestParameters: RunbooksAPIApiRunbooksAPICreateRunbookRequest, options?: RawAxiosRequestConfig) {
        return RunbooksAPIApiFp(this.configuration).runbooksAPICreateRunbook(requestParameters.runbookOrganizationId, requestParameters.runbookClusterId, requestParameters.createRunbookRequestRunbook, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes the runbook for the given cluster.
     * @summary Delete runbooks for the given cluster.
     * @param {RunbooksAPIApiRunbooksAPIDeleteRunbookRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RunbooksAPIApi
     */
    public runbooksAPIDeleteRunbook(requestParameters: RunbooksAPIApiRunbooksAPIDeleteRunbookRequest, options?: RawAxiosRequestConfig) {
        return RunbooksAPIApiFp(this.configuration).runbooksAPIDeleteRunbook(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete integrations from a runbook.
     * @summary Delete integrations from a given runbook.
     * @param {RunbooksAPIApiRunbooksAPIDeleteRunbookIntegrationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RunbooksAPIApi
     */
    public runbooksAPIDeleteRunbookIntegrations(requestParameters: RunbooksAPIApiRunbooksAPIDeleteRunbookIntegrationsRequest, options?: RawAxiosRequestConfig) {
        return RunbooksAPIApiFp(this.configuration).runbooksAPIDeleteRunbookIntegrations(requestParameters.organizationId, requestParameters.clusterId, requestParameters.runbookId, requestParameters.integrationIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List integrations for a runbook.
     * @summary List integrations for the given runbook.
     * @param {RunbooksAPIApiRunbooksAPIListRunbookIntegrationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RunbooksAPIApi
     */
    public runbooksAPIListRunbookIntegrations(requestParameters: RunbooksAPIApiRunbooksAPIListRunbookIntegrationsRequest, options?: RawAxiosRequestConfig) {
        return RunbooksAPIApiFp(this.configuration).runbooksAPIListRunbookIntegrations(requestParameters.organizationId, requestParameters.clusterId, requestParameters.runbookId, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List runbooks for the given cluster.
     * @summary List runbooks for the given cluster.
     * @param {RunbooksAPIApiRunbooksAPIListRunbooksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RunbooksAPIApi
     */
    public runbooksAPIListRunbooks(requestParameters: RunbooksAPIApiRunbooksAPIListRunbooksRequest, options?: RawAxiosRequestConfig) {
        return RunbooksAPIApiFp(this.configuration).runbooksAPIListRunbooks(requestParameters.organizationId, requestParameters.clusterId, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List runbooks for the given organization.
     * @summary List runbooks for the given organization.
     * @param {RunbooksAPIApiRunbooksAPIListRunbooksOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RunbooksAPIApi
     */
    public runbooksAPIListRunbooksOrganization(requestParameters: RunbooksAPIApiRunbooksAPIListRunbooksOrganizationRequest, options?: RawAxiosRequestConfig) {
        return RunbooksAPIApiFp(this.configuration).runbooksAPIListRunbooksOrganization(requestParameters.organizationId, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates runbook for the given cluster.
     * @summary Updates a runbook for the given cluster.
     * @param {RunbooksAPIApiRunbooksAPIUpdateRunbookRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RunbooksAPIApi
     */
    public runbooksAPIUpdateRunbook(requestParameters: RunbooksAPIApiRunbooksAPIUpdateRunbookRequest, options?: RawAxiosRequestConfig) {
        return RunbooksAPIApiFp(this.configuration).runbooksAPIUpdateRunbook(requestParameters.runbookOrganizationId, requestParameters.runbookClusterId, requestParameters.runbookId, requestParameters.updateRunbookRequestRunbook, options).then((request) => request(this.axios, this.basePath));
    }
}

